export const stitcherUserEmails = new Set([
  'dario.salic90@gmail.com',
  'shiloasi@gmail.com',
  'bane+all@shigotech.io',
  'shilo@shigotech.io',
  'administrator@shigotech.io',
  'ilan@shigotech.io',
  'jenny@smartbid.ai',
  'shahar@smartbid.ai',
  'raz@smartbid.ai',
  'or@smartbid.ai',
  'stav@smartbid.ai',
  'aaron@altentiv.com',
  'rahul@shigotech.io',
  'oveeotest@mail.com',
  'rahul@benefit-ads.com',
]);
